module.exports = __webpack_public_path__ + "static/media/ArrowDown.9893f18f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ArrowDown.svg
// module id = 1045
// module chunks = 0